
// 封装接口后台封装调用

import axios from '../axios/axios'

//设置个对象，就不用一个个暴露了，直接暴露对象
let serverApi = {};


serverApi.mergeShopPay = function(params) {
  return axios.post(api+'insurance.OrderInfoProductLz/mergeShopPay', params)
}
serverApi.shopPayList = function(params) {
  return axios.post(api+'shop.shop_pay_read_lz/getShopPayList', params)
}
/* 获取列表 */
//查询列表，详情就是get
/* /api/getlist是请求接口地址，有http.js里面的Ip加上，如：http:192.168.0.1:9090//api/getlist  */
// apiFun.getlist = function(params) {
let api = 'api/'
// let api = '' // 当前线上
let baiduyun = 'baiduyun/'

serverApi.getGroupPayList = function(params) {
  return axios.post(api+'insurance.order_info_product_read_lz/getGroupShopOrderList', params)
}

serverApi.getAdmin = function(params) {
  return axios.post(api+'sys.Company_user_read_lz/login', params)
}

serverApi.getADepositList = function(params) {
  return axios.post(api+'car.car_ya_jin_read_lz/getCarYaJinInfo', params)
}

/** ================guzixia ===============*/
//======车辆档案相关接口
//车辆押金信息列表
serverApi.getDepositList = function(params) {
  return axios.post(api+'car.car_ya_jin_read_lz/getCarYaJinList', params)
}
//车辆信息修改新增保存
serverApi.saveDeposit = function(params) {
  return axios.post(api+'car.car_ya_jin_lz/save', params)
}
//车辆押金列表删除
serverApi.delDepositList = function(params) {
  return axios.post(api+'car.car_ya_jin_lz/del', params)
}

// 车辆信息列表
serverApi.getCarList  = function(params) {
  return axios.post(api+'/car.car_read_lz/getCarInfoList', params)
}

// 运输公司 -- 车辆查询 -- 列表 -- 单列数据
serverApi.shopGetShopList  = function(params) {
  return axios.post(api+'/shop.shop_read_lz/getShopList', params)
}
//过户列表 transfer ownership
serverApi.getTranOwnList = function(params) {
  return axios.post(api+'car.car_guo_hu_read_lz/getCarGuoHuList', params)
}
//修改新增过户列表
serverApi.saveTranOwn = function(params) {
  return axios.post(api+'car.car_guo_hu_lz/save', params)
}
//删除车辆过户信息
serverApi.deTranOwn  = function(params) {
  return axios.post(api+'car.car_guo_hu_lz/del', params)
}
//过出列表
serverApi.getOverstep  = function(params) {
  return axios.post(api+'car.car_guo_chu_read_lz/getCarGuoChuList', params)
}
//新增|保存过出信息
serverApi.saveOverstep  = function(params) {
  return axios.post(api+'car.car_guo_chu_lz/save', params)
}
//删除过出信息
serverApi.delOverstep  = function(params) {
  return axios.post(api+'car.car_guo_chu_lz/del', params)
}

//报停列表
serverApi.getAlarmStop  = function(params) {
  return axios.post(api+'car.car_bao_ting_read_lz/getCarBaoTingList', params)
}
//报停新增|修改
serverApi.saveAlarmStop  = function(params) {
  return axios.post(api+'car.car_bao_ting_lz/save', params)
}
//报停删除
serverApi.delAlarmStop  = function(params) {
  return axios.post(api+'car.car_bao_ting_lz/del', params)
}

//补换列表
serverApi.getReplace  = function(params) {
  return axios.post(api+'car.car_pai_zheng_read_lz/getCarPaiZhengList', params)
}
//补换增加|修改
serverApi.saveReplace  = function(params) {
  return axios.post(api+'car.car_pai_zheng_lz/save', params)
}
//补换删除
serverApi.delReplace  = function(params) {
  return axios.post(api+'car.car_pai_zheng_lz/del', params)
}


//=====费用管理
//管理费用列表
serverApi.getManageCost  = function(params) {
  return axios.post(api+'fee.manage_fee_read_lz/getManageRemindList', params)
}
//保存车辆管理费用
serverApi.saveManageCost  = function(params) {
  return axios.post(api+'fee.manage_fee_lz/save', params)
}
//删除车辆管理费用
serverApi.delManageCost  = function(params) {
  return axios.post(api+'fee.manage_fee_lz/del', params)
}

//运营证年审列表
serverApi.getAnnualAudit  = function(params) {
  return axios.post(api+'fee.trad_fee_read_lz/getTradList', params)
}
//保存车辆营运证年审信息
serverApi.saveAnnualAudit  = function(params) {
  return axios.post(api+'fee.trad_fee_lz/save', params)
}
//删除运营年审 todo
serverApi.delAnnualAudit  = function(params) {
  return axios.post(api+'fee.trad_fee_lz/del', params)
}
//===驾驶证列表
serverApi.getDrivingLicence = function(params) {
  return axios.post(api+'fee.drive_read_lz/getDriveList', params)
}
//==驾驶证保存
serverApi.saveDrivingLicence = function(params) {
  return axios.post(api+'fee.drive_lz/save', params)
}
//==驾驶证删除
serverApi.delDrivingLicence = function(params) {
  return axios.post(api+'fee.drive_lz/del', params)
}

//==费用管理-二级维护列表
serverApi.getTwoFeeList = function(params) {
  return axios.post(api+'fee.two_fee_read_lz/getTwoFeeList', params)
}
//==费用管理-二级维护列表保存
serverApi.saveTwoFeeList = function(params) {
  return axios.post(api+'fee.two_fee_lz/save', params)
}
//==费用管理-删除二级维护列表
serverApi.delTwoFeeList = function(params) {
  return axios.post(api+'fee.two_fee_lz/del', params)
}
//==管理费用

//==车辆其他费用接口
serverApi.getOtherFeeList = function(params) {
  return axios.post(api+'fee.other_fee_read_lz/getOtherFeeList', params)
}
//保存车辆其他费用接口
serverApi.saveOtherFee = function(params) {
  return axios.post(api+'fee.other_fee_lz/save', params)
}
//删除车辆其他费用接口
serverApi.delOtherFee = function(params) {
  return axios.post(api+'fee.other_fee_lz/del', params)
}

//车辆年审列表
serverApi.getExamination = function(params) {
  return axios.post(api+'fee.annual_read_lz/getAnnualFeeList', params)
}
//车辆年审修改
serverApi.saveExamination = function(params) {
  return axios.post(api+'fee.annual_lz/save', params)
}
//车辆年审删除
serverApi.delExamination = function(params) {
  return axios.post(api+'fee.annual_lz/del', params)
}

//车辆等级评定 列表
serverApi.getGradeFee = function(params) {
  return axios.post(api+'fee.grade_read_lz/getGradeFeeList', params)
}
//车辆等级评定费用保存信息
serverApi.saveGradeFee = function(params) {
  return axios.post(api+'fee.grade_lz/save', params)
} ,
//车辆等级评定费用删除
serverApi.delGradeFee = function(params) {
  return axios.post(api+'fee.grade_lz/del', params)
}

//从业资格证列表
serverApi.getOccupational = function(params) {
  return axios.post(api+'fee.practice_read_lz/getPracticeList', params)
}
//从业资格证保存信息
serverApi.saveOccupational = function(params) {
  return axios.post(api+'fee.practice_lz/save', params)
}
//删除从业资格证
serverApi.delOccupational = function(params) {
  return axios.post(api+'fee.practice_lz/del', params)
}
//评定（审核）人列表
serverApi.getAssessor = function(params) {
  return axios.post(api+'sys.car_audit_read_Lz/getCarAuditList', params)
},
//新增|修改评定（审核）人
serverApi.saveAssessor = function(params) {
  return axios.post(api+'sys.car_audit_Lz/save', params)
}
//删除 评定（审核）人
serverApi.delAssessor = function(params) {
  return axios.post(api+'sys.car_audit_Lz/del', params)
}

//====到期提醒
//管理到期提醒列表 remind.remind_read_lz/getManageRemindList
serverApi.getManageRemindList  = function(params) {
  return axios.post(api+'remind.remind_read_lz/getManageRemindList', params)
}
//--保险到期

//二级维护到期提醒列表
serverApi.getTwoFeeRemindList  = function(params) {
  return axios.post(api+'remind.remind_read_lz/getTwoFeeRemindList', params)
}
//从业资格证列表
serverApi.getPracticeRemindList  = function(params) {
  return axios.post(api+'remind.remind_read_lz/getPracticeRemindList', params)
}
//驾驶证到期提醒
serverApi.getDriveRemindList  = function(params) {
  return axios.post(api+'remind.remind_read_lz/getDriveRemindList', params)
}
//运营证到期提醒
serverApi.getTradRemindList  = function(params) {
  return axios.post(api+'remind.remind_read_lz/getTradRemindList', params)
}
//车辆年审到期
serverApi.getAnnualRemindList  = function(params) {
  return axios.post(api+'remind.remind_read_lz/getAnnualRemindList', params)
}
//车辆等级评定到期 remind.remind_read_lz/getGradeFeeRemindList
serverApi.getGradeFeeRemindList  = function(params) {
  return axios.post(api+'remind.remind_read_lz/getGradeFeeRemindList', params)
}
//其他费用到期提醒
serverApi.getOtherFeeRemindList  = function(params) {
  return axios.post(api+'remind.remind_read_lz/getOtherFeeRemindList', params)
}

//运输公司支付列表
serverApi.getShopPayPageList  = function(params) {
  return axios.post(api+'shop.shop_pay_read_lz/getShopPayPageList', params)
}
//修改运输公司支付列表
serverApi.saveShopPayPageList  = function(params) {
  return axios.post(api+'shop.shop_pay_lz/save', params)
}
//删除运输公司支付列表
serverApi.delShopPayPageList  = function(params) {
  return axios.post(api+'shop.shop_pay_lz/del', params)
}

//运输公司增加|修改
//运输公司删除


//=======首页相关接口
//公告表
serverApi.getNotice  = function(params) {
  return axios.post(api+'sys.msg_read_lz/getMsgList', params)
}
//获取根据年度折线图统计数据
serverApi.getShopChartInfo  = function(params) {
  return axios.post(api+'sys.index_read_lz/getShopChartInfo', params)
}
//首页接口
serverApi.getIndexInfo  = function(params) {
  return axios.post(api+'sys.index_read_lz/getShopIndexPage', params)
}

//合同签署
serverApi.createFileByOrder  = function(params) {
  return axios.post(api+'esign.esign_file_flow_Lz/createFileByOrder', params)
}
//查看合同
serverApi.getFileSignUrl  = function(params) {
  return axios.post(api+'esign.sign_flow_Lz/getFileSignUrl', params)
}

//查看电子签章（合同接口）
serverApi.getEsignFileFlowList  = function(params) {
  return axios.post(api+'esign.esign_file_flow_read_lz/getEsignFileFlowList', params)
}
//下载合同
serverApi.downloadFileUrl  = function(params) {
  return axios.post(api+'esign.sign_flow_Lz/downloadFileUrl', params)
}

//车辆档案-档案管理 百度获取百度云OCR
serverApi.getAccessToken  = function(params) {
  return axios.post(api+'sys.ocrVehicle/getAccessToken', params)
}

// 获取其他渠道列表
serverApi.getOtherChannelList  = function(params) {
  return axios.post(api+'insurance.other_channel_read_Lz/getOtherChannelList', params)
}

//增加修改 其他渠道数据
serverApi.saveOtherChannel  = function(params) {
  return axios.post(api+'insurance.other_channel_Lz/save', params)
}
//删除其他渠道数据 insurance.other_channel_Lz/del
serverApi.delOtherChannel  = function(params) {
  return axios.post(api+'insurance.other_channel_Lz/del', params)
}
//团单订单添加-其他渠道-保存订单数据-单车多险种
serverApi.saveGroupByCar  = function(params) {
  return axios.post(api+'insurance.order_info_Lz/saveGroupByCar', params)
}
//团单订单
serverApi.saveGroupByProduct  = function(params) {
  return axios.post(api+'insurance.order_info_Lz/saveGroupByProduct', params)
}
//根据运输公司名称查询运输公司信息
serverApi.getShopInfoByName  = function(params) {
  return axios.post(api+'shop.shop_lz/getShopInfoByName', params)
}
//保险管理-待处理保险 编辑
serverApi.editOrderInfo  = function(params) {
  return axios.post(api+'insurance.order_info_product_lz/editOrderInfo', params)
}
//保险管理-待处理保险列表-取消订单按钮
serverApi.cancelOrderInfo  = function(params) {
  return axios.post(api+'insurance.order_info_product_lz/cancelOrderInfo', params)
}
//运输公司后台pc端-用户中心-用户信息返回
serverApi.getEmployeeInfo  = function(params) {
  return axios.post(api+'sys.employee_read_Lz/getEmployeeInfo', params)
}

//对公支付相关
//系统待处理保险 - 对公支付订单列表
serverApi.getGroupShopOrderList  = function(params) {
  return axios.post(api+'insurance.order_info_product_read_lz/getGroupShopOrderList', params)
}

//修改密码
serverApi.setPassword  = function(params) {
  return axios.post(api+'sys.employee_Lz/setPassword', params)
}

//查询机构认证信息
serverApi.getOrgAuthInfo  = function(params) {
  return axios.post(api+'esign.esign_org_Lz/getOrgAuthInfo', params)
}
//查询企业授权详情
serverApi.setOrgAuthorizehUrl  = function(params) {
  return axios.post(api+'esign.esign_org_Lz/setOrgAuthorizehUrl', params)
}

/**========================end================================*/



serverApi.companyModuleList = function(params) {
  return axios.post(api+'sys.Company_module_read_lz/getTree', params)
}
//客户贷款列表
serverApi.loanList = function(params) {
  return axios.post(api+'loan.loan_read_lz/getLoanList', params)
}

//客户借款列表
serverApi.borrowList = function(params) {
  return axios.post(api+'borrow.borrow_read_lz/getBorrowList', params)
}
//客户借款还款计划列表
serverApi.borrowPayPlanList = function(params) {
  return axios.post(api+'borrow.borrow_read_lz/getBorrowPayPlanList', params)
}
//客户借款还款列表
serverApi.borrowPayList = function(params) {
  return axios.post(api+'borrow.borrow_read_lz/getBorrowPayList', params)
}

//到期提醒-管理费列表
serverApi.remindManageList = function(params) {
  return axios.post(api+'remind.remind_read_lz/getManageRemindList', params)
}

// 角色管理--设置权限
serverApi.roleSetPower = function(params) {
  return axios.post(api+'/api.sys.Company_role_lz/setPower', params)
}
// 菜单添加
serverApi.companyModuleSave = function(params) {
  return axios.post(api+'/api.sys.Company_module_lz/save', params)
}
//获取投保人列表
serverApi.shopList = function(params) {
  return axios.post(api+'shop.shop_read_lz/getShopList', params)
}
// 运输公司列表
serverApi.shipCompanyList = function(params) {
  return axios.post(api+'/api.crm.Shop_read_lz/findListP', params)
}


// 运输公司列表--不分页
serverApi.shipCompanyNoPage = function(params) {
  return axios.post(api+'/api.crm.Shop_read_lz/list', params)
}

// 运输公司详情
serverApi.shipCompanyDetails = function(params) {
  return axios.post(api+'/api.crm.Shop_read_lz/findOne', params)
}

// 车辆列表
serverApi.carQueryList = function(params) {
  return axios.post(api+'/api.crm.Car_read_lz/findListP', params)
}
//车辆档案列表
serverApi.carList = function(params) {
  return axios.post(api+'car.car_read_lz/getCarInfoList', params)
}
serverApi.carFilesList = function(params) {
  return axios.post(api+'car.car_read_lz/getCarFilesList', params)
}
serverApi.carInfo = function(params) {
  return axios.post(api+'car.car_read_lz/getCarFilesInfo', params)
}

//车辆档案新增，编辑
serverApi.saveCar = function(params) {
  return axios.post(api+'car.car_lz/save', params)
}
//车辆档案删除
serverApi.delCar = function(params) {
  return axios.post(api+'car.car_lz/del', params)
}
//车辆过户 transferCar
serverApi.transferCar = function(params) {
  return axios.post(api+'car.car_lz/transfer', params)
}
//车辆过户/报销 列表
serverApi.transCarList = function(params) {
  return axios.post(api+'car.car_lz/transCarList', params)
}
//取消车辆过户/报销
serverApi.cancelCar = function(params) {
  return axios.post(api+'car.car_lz/cancelCar', params)
}
//车辆档案详情
serverApi.findCarOne = function(params) {
  return axios.post(api+'car.car_lz/findOne', params)
}

// 车辆添加
serverApi.carQuerySave = function(params) {
  return axios.post(api+'/api.crm.Car_lz/editInfo', params)
}

serverApi.remindInsuranceList = function(params) {
  return axios.post(api+'remind.remind_read_lz/getCarRemindInfo', params)
}
serverApi.remindInsuranceSumList = function(params) {
  return axios.post(api+'remind.remind_read_lz/getCarInsureRemindSum', params)
}
//订单不续保或者车辆过户操作
serverApi.goNoRenewalDeal = function(params) {
  return axios.post(api+'remind.remind_read_lz/noRenewalDeal', params)
}

// 车辆详情--主车信息
serverApi.carQueryDetails = function(params) {
  return axios.post(api+'/api.crm.Car_read_lz/findOne', params)
}

// 员工列表
serverApi.employeeList = function(params) {
  return axios.post(api+'sys.Employee_read_lz/findListP', params)
}



// 员工列表-不分页
serverApi.employeeNoPage = function(params) {
  return axios.post(api+'/api.sys.Employee_read_lz/findListAll', params)
}

// 添加员工
serverApi.employeeSave = function(params) {
  return axios.post(api+'sys.Employee_lz/save', params)
}

// 用户列表
serverApi.userList = function(params) {
  return axios.post(api+'sys.Cmp_user_read_lz/findListP', params)
}

// 用户列表添加/编辑
serverApi.usersave = function(params) {
  return axios.post(api+'sys.Cmp_user_lz/save', params)
}


// 用户列表-删除
serverApi.userDel = function(params) {
  return axios.post(api+'sys.Cmp_user_lz/del', params)
}


// 用户列表-设置员工账号密码
serverApi.setUserLoginInfo = function(params) {
  return axios.post(api+'/api.sys.Cmp_user_lz/setUserLoginInfo', params)
}

// 用户列表-员工修改账号密码
serverApi.changePassword = function(params) {
  return axios.post(api+'/api.sys.Cmp_user_lz/changePassword', params)
}

// 用户列表-员工状态修改
serverApi.cmpUserChangeStatus = function(params) {
  return axios.post(api+'/api.sys.Cmp_user_lz/changeStatus', params)
}


// 部门列表
serverApi.departmentList = function(params) {
  return axios.post(api+'sys.Department_read_lz/findListP', params)
}

// 获取部门
serverApi.findTree = function(params) {
  return axios.post(api+'sys.Department_read_lz/findTree', params)
}

// 部门添加
serverApi.departmentSave = function(params) {
  return axios.post(api+'sys.Department_lz/save', params)
}

// 角色列表
serverApi.roleList = function(params) {
  return axios.post(api+'sys.Company_role_read_lz/findListP', params)
}
// 获取角色
serverApi.rolefindTree = function(params) {
  return axios.post(api+'/api.sys.Company_role_read_lz/findTree', params)
}
// 角色添加
serverApi.roleSave = function(params) {
  return axios.post(api+'/api.sys.Company_role__lz/save', params)
}

// 角色 -- 修改状态
serverApi.roleChangeStatus = function(params) {
  return axios.post(api+'/api.sys.Company_role_lz/changeStatus', params)
}


// 角色选择更新
serverApi.roleAddModule = function(params) {
  return axios.post(api+'/api.sys.Company_role_lz/addModule', params)
}

// 角色删除
serverApi.roleDelModule = function(params) {
  return axios.post(api+'/api.sys.Company_role_lz/del', params)
}


// 保险订单列表
serverApi.getInsuranceOrderList = function(params) {
  //return axios.post(api+'insurance.order_info_product_read_lz/insuranceOrderList', params)
  return axios.post(api+'insurance.order_info_product_read_lz/getInsuranceOrderList', params)
}

// 业务渠道列表
serverApi.crmMembeList = function(params) {
  return axios.post(api+'/api.crm.Member_read_lz/findListP', params)
}

// 业务渠道列表--不分页
serverApi.crmMembeListNoPage = function(params) {
  return axios.post(api+'/api.crm.Member_read_lz/list', params)
}

// 业务渠道添加
serverApi.crmMembeSave = function(params) {
  return axios.post(api+'/api.crm.Member_lz/save', params)
}


// 业务渠道-删除
serverApi.crmMembeDel = function(params) {
  return axios.post(api+'/api.crm.Member_lz/del', params)
}


//保险险种-列表
serverApi.insuranceProdcutList = function(params) {
  return axios.post(api+'insurance.Product_read_lz/getProductList', params)
}

//获取车辆年限 getCarLimitTime
serverApi.getCarLimitTime = async function (params) {
  return await axios.post(api + 'insurance.order_info_lz/getCarLimitTime', params)
}

// 险种方案信息  产品方案-列表
serverApi.insuranceProductMdList = function(params) {
  return axios.post(api+'insurance.product_md_read_lz/getProductMdList', params)
}

// 保险订单新增页面用到的，险种方案列表
serverApi.insuranceProductList = function(params) {
  return axios.post(api+'/api.insurance.Product_md_read_lz/findList', params)
}

// 险种方案信息  产品方案-列表--不分页
serverApi.insProductNoPage = function(params) {
  return axios.post(api+'/api.insurance.Product_md_read_lz/list', params)
}

// 险种方案信息  产品方案--编辑/添加
serverApi.insuranceProductMdSave = function(params) {
  return axios.post(api+'/api.insurance.Product_md_lz/save', params)
}

// 险种方案信息   产品方案--禁用
serverApi.insuranceProductMdUpdateStatus = function(params) {
  return axios.post(api+'/api.insurance.Product_md_lz/updateStatus', params)
}


// 被保险人信息
serverApi.OwnerList = function(params) {
  return axios.post(api+'/api.crm.Owner_read_lz/findListP', params)
}

// 被保险人信息--不分页
serverApi.OwnerNoPage = function(params) {
  return axios.post(api+'/api.crm.Owner_read_lz/list', params)
}

// 支付凭证信息-------------
serverApi.payProductOneList = function(params) {
  return axios.post(api+'/api.insurance.Product_pay_read_lz/findOne', params)
}

// 支付凭证列表
serverApi.payProductList = function(params) {
  return axios.post(api+'/api.insurance.Product_pay_read_lz/findListP', params)
}



// 支付凭证添加
serverApi.payProductSave = function(params) {
  return axios.post(api+'/api.insurance.Product_pay_lz/save', params)
}

//获取access_token方法
serverApi.getTokenBaidu = function(params) {
  return axios.get(baiduyun+'/oauth/2.0/token?grant_type=client_credentials&client_id=maBmcgsFd8xylDCF07jwnpFm&client_secret=37K8UQeDKERZDml0mNngeTRHG6G2m34u&', params)
}
serverApi.getOCRVehicleLicense = function(params) {
  let token = sessionStorage.getItem("access_token")
  console.log(token,99886);
  return axios.postForm(baiduyun+'/rest/2.0/ocr/v1/vehicle_license?access_token='+sessionStorage.getItem("access_token"), params)
}

// 百度云--行驶证识别
serverApi.ocrVehicle = function(params) {
  return axios.post(api+'/api.sys.Ocr_vehicle/ocrVehicleNew', params)
}

// 阿里云--行驶证识别
serverApi.aliyunOcrVehicle = function(params) {
  return axios.post(api+'/api.sys.aliyun_ocr_vehicle/ocrVehicleNew', params)
}

// 营业执照识别
serverApi.ocrShop = function(params) {
  return axios.post(api+'/api.sys.Ocr_vehicle/ocrShop', params)
}

// 身份证识别
serverApi.ocrIDCard = function(params) {
  return axios.post(api+'/api.sys.Ocr_vehicle/ocrIDCard', params)
}



// 图片识别
// serverApi.getXszOCR = function(params) {
//   let token = sessionStorage.getItem("access_token")
//   console.log(token,99886);
//   return axios.post(baiduyun+'/rest/2.0/ocr/v1/table?access_token='+sessionStorage.getItem("access_token"), params)
// }

// // 退出
// serverApi.getOutAdmin = function(params) {
//   return axios.get('/login/out', params)
// }



// 单车多产品
serverApi.saveOrderByCar = function(params) {
  return axios.post(api+'insurance.order_info_lz/saveOrderByCar', params)
}
// 单产品多车
serverApi.saveOrderByProduct = function(params) {
  return axios.post(api+'insurance.order_info_lz/saveOrderByProduct', params)
}
// 多车多运输公司单产品
serverApi.saveOrderBySysProduct = function(params) {
  return axios.post(api+'insurance.order_info_lz/saveOrderBySysProduct', params)
}
//单车多保险
serverApi.saveOrderBySysCar = function(params) {
  return axios.post(api+'insurance.order_info_lz/saveOrderBySysCar', params)
}


// 单一订单添加
serverApi.insuranceOrderInfoSave = function(params) {
  return axios.post(api+'/api.insurance.Order_info_lz/singleSaveNew', params)
}
// 单一订单 获取 SN
serverApi.insuranceOrderInfoGetSn = function(params) {
  return axios.post(api+'/api.insurance.Order_info_lz/getSn', params)
}


// 产品渠道 -- 列表
serverApi.insuranceCorpChannelList = function(params) {
  return axios.post(api+'/api.insurance.Corp_channel_read_lz/findListP', params)
}

// 产品渠道-添加/编辑
serverApi.insuranceCorpChannelSave = function(params) {
  return axios.post(api+'/api.insurance.Corp_channel_lz/save', params)
}

// 产品渠道-删除
serverApi.insuranceCorpChannelDel = function(params) {
  return axios.post(api+'/api.insurance.Corp_channel_lz/del', params)
}

// 产品列表
serverApi.insuranceProductlList = function(params) {
  return axios.post(api+'/api.insurance.Product_read_lz/findListP', params)
}

// 产品列表-添加/编辑
serverApi.insuranceProductlSave = function(params) {
  return axios.post(api+'/api.insurance.Product_lz/save', params)
}

// 产品列表 -- 删除
serverApi.insuranceProductlDel = function(params) {
  return axios.post(api+'/api.insurance.Product_lz/del', params)
}

// 订单列表 new
serverApi.OrderProductSqlList = function(params) {
  return axios.post(api+'insurance.order_info_product_read_lz/insuranceOrderList', params)
}

serverApi.OrderSave = function(params) {
  return axios.post(api+'insurance.order_info_lz/save', params)
}

// 订单处理同步 -- 销售
serverApi.OrderProductSqlUpdatePay = function(params) {
  return axios.post(api+'/api.insurance.Order_info_product_lz/updatePay', params)
}


// 订单-指定分配的出单人
serverApi.OrderInfoAppointUser = function(params) {
  return axios.post(api+'/api.insurance.Order_info_lz/appointUser', params)
}

// 团队管理-列表
serverApi.TeamsList = function(params) {
  return axios.post(api+'/api.sys.Team_items_read_lz/getTeamList', params)
}

// 团队管理-修改/添加
serverApi.TeamsEditTeam = function(params) {
  return axios.post(api+'/api.sys.Team_items_read_lz/editTeam', params)
}

// 组员管理-列表
serverApi.TeamsItemList = function(params) {
  return axios.post(api+'/api.sys.Team_items_read_lz/getTeamItemList', params)
}

// 组员管理-修改/添加
serverApi.TeamsItemSave = function(params) {
  return axios.post(api+'/api.sys.Team_items_read_lz/addTeamItem', params)
}

// 组员管理-列表
serverApi.TeamsItemDel = function(params) {
  return axios.post(api+'/api.sys.Team_items_read_lz/delTeamItem', params)
}


// 产品分类-列表
serverApi.ProductCategoryList = function(params) {
  return axios.post(api+'/api.insurance.Product_Category_read_lz/findListP', params)
}

// 产品分类-修改/添加
serverApi.ProductCategorySave = function(params) {
  return axios.post(api+'/api.insurance.Product_Category_lz/save', params)
}

// 产品分类-删除
serverApi.ProductCategoryDel = function(params) {
  return axios.post(api+'/api.insurance.product_category_lz/del', params)
}

// 保险公司-列表
serverApi.insuranceCorpList = function(params) {
  return axios.post(api+'/api.insurance.corp_read_lz/findListP', params)
}

// // 产品分类-列表
// serverApi.ProductCategoryList = function(params) {
//   return axios.post(api+'/api.insurance.corp_read_lz/findListP', params)
// }

// // 产品分类-修改/添加
// serverApi.ProductCategorySave = function(params) {
//   return axios.post(api+'/api.insurance.corp_read_lz/findListP', params)
// }

// 保险公司-列表-不分页
serverApi.insuranceCorpNoList = function(params) {
  return axios.post(api+'/api.insurance.corp_read_lz/list', params)
}

// 保险公司-列表
serverApi.insuranceCorpList = function(params) {
  return axios.post(api+'insurance.corp_read_lz/findListP', params)
}

// 保险公司-添加/编辑
serverApi.insuranceCorpSave = function(params) {
  return axios.post(api+'insurance.corp_lz/save', params)
}

// 保险公司-删除
serverApi.insuranceCorpDel = function(params) {
  return axios.post(api+'insurance.corp_lz/del', params)
}

// 运输公司-列表
/*
serverApi.shopList = function(params) {
  return axios.post(api+'shop.shop_read_lz/getShopList', params)
}*/
//被投保人
/*
serverApi.shopList = function(params) {
  return axios.post(api+'shop.shop_read_lz/getShopList', params)
}*/

//保司列表
serverApi.corpList = function(params) {
  return axios.post(api+'insurance.corp_read_lz/getCorpList', params)
}


// 运输公司-添加/编辑
serverApi.shopListSave = function(params) {
  return axios.post(api+'/api.crm.shop_lz/save', params)
}

// 运输公司-删除
serverApi.shopListDel = function(params) {
  return axios.post(api+'/api.crm.shop_lz/del', params)
}

// 上传文件(类型：1行驶证2营业执照3身份证4保单5支付凭证6佣金凭证 8车辆绑定的商业险保单信息9运输公司绑定的投保声明信息)
serverApi.ossUploadFile = function(params) {
  return axios.post(api+'sys.oss_upload/uploadFile', params)
}

// 获取getPaySn
serverApi.getPaySN = function(params) {
  return axios.post(api+'/api.insurance.Product_pay_lz/getPaySn', params)
}

// 支付凭证上传图片
serverApi.toolUploadAliLay = function(params) {
  return axios.post(api+'/api.sys.Oss_upload/file2Oss', params)
}

// 财务票据-识别银行回单信息
serverApi.ocrBankReceiptNew = function(params) {
  return axios.post(api+'/api.sys.Ocr_vehicle/ocrBankReceiptNew', params)
}

// 保存支付凭证 - 合并支付
serverApi.payMergePay = function(params) {
  return axios.post(api+'/api.insurance.Product_pay_lz/mergePay', params)
}

// 订单处理 - -更新订单信息
serverApi.payProductEdit = function(params) {
  return axios.post(api+'/api.insurance.order_info_product_lz/editOrderInfo', params)
}

// 订单处理-(当前登录帐号绑定的出单人看的)订单列表
serverApi.issuerOrderList = function(params) {
  return axios.post(api+'/api.insurance.Order_info_product_read_lz/issuerOrderList', params)
}
serverApi.issuerOrderList = function(params) {
  return axios.post(api+'/api.insurance.Order_info_product_read_lz/issuerOrderList', params)
}

// 财务管理-待审核订单-审核
serverApi.issuerOrderAudit = function(params) {
  return axios.post(api+'/api.insurance.order_info_lz/audit', params)
}

// 财务管理-应收账款
serverApi.noReceiveList = function(params) {
  return axios.post(api+'/api.finance.pay_order_read_lz/noReceiveList', params)
}

// 财务管理--已收账款
serverApi.receiveList = function(params) {
  return axios.post(api+'/api.finance.pay_order_read_lz/receiveList', params)
}

// 部门管理列表 -- 树结构
serverApi.departmentTree = function(params) {
  return axios.post(api+'sys.Department_read_lz/findTree', params)
}

// 部门管理 -- 删除
serverApi.departmentDel = function(params) {
  return axios.post(api+'/api.sys.department_Lz/del', params)
}

// 运输公司 -- 维护人员管理--列表
serverApi.shopBindList = function(params) {
  return axios.post(api+'/api.sys.shop_bind_read_lz/findListP', params)
}

// 运输公司 -- 维护人员管理--新增/编辑
serverApi.shopBindSave = function(params) {
  return axios.post(api+'/api.sys.shop_bind_Lz/save', params)
}

// 运输公司 -- 维护人员管理--删除
serverApi.shopBindDel = function(params) {
  return axios.post(api+'/api.sys.shop_bind_Lz/del', params)
}

// 维护人员管理列表，运输公司使用的
serverApi.shopUseBind = function(params) {
  return axios.post(api+'/api.sys.shop_bind_read_lz/list', params)
}
// 后台登录用户绑定运营公司帐号，可绑定多个
serverApi.cmpUserBindShop  = function(params) {
  return axios.post(api+'/api.sys.Cmp_user_lz/bindShop', params)
}

// 运输公司 -- 个人/公司订单添加
serverApi.shopSaveOrderNew  = function(params) {
  return axios.post(api+'/api.insurance.order_info_lz/shopSaveOrderNew', params)
}

// 运输公司 -- 运输公司 -- 列表
serverApi.shopShopList  = function(params) {
  return axios.post(api+'shop.shop_read_lz/findListP', params)
}

// 运输公司 -- 运输公司 -- 新增/编辑
serverApi.shopShopSave  = function(params) {
  return axios.post(api+'shop.shop_lz/save', params)
}

// 运输公司 -- 运输公司 -- 删除
serverApi.shopShopDel  = function(params) {
  return axios.post(api+'shop.shop_lz/del', params)
}

// 运输公司 -- 订单处理
serverApi.shopOrderDeal = function(params) {
  return axios.post(api+'/api.insurance.Order_info_product_read_lz/shopOrderList', params)
}

// 保险到期提醒
serverApi.shopRemind = function(params) {
  return axios.post(api+'/api.shop.remind_read_lz/findListP', params)
}



// 根据type传值，得到到期提醒列表信息
serverApi.shopRemindList = function(params) {
  return axios.post(api+'/api.shop.remind_read_lz/list', params)
}

// 国任出单 -- 订单列表
serverApi.guorenOrderList = function(params) {
  return axios.post(api+'/api.guoren.order_info_read_lz/findList', params)
}

// 国任对接电子非见费承保 -- 是否出单
serverApi.IsUnderwrite = function(params) {
  return axios.post(api+'/api.guoren.order_info_lz/underwrite', params)
}

// 国任出单 -- 电子保单
serverApi.guorenGetEpolicyUrl = function(params) {
  return axios.post(api+'/api.guoren.order_info_read_lz/getEpolicyUrl', params)
}

// 国任出单 -- 电子发票
serverApi.guorenGetInvoiceUrl = function(params) {
  return axios.post(api+'/api.guoren.order_info_read_lz/getInvoiceUrl', params)
}

// 国任出单 -- 上传文件(文件类型：4保单7电子发票
serverApi.guorenFileUpload = function(params) {
  return axios.post(api+'/api.guoren.order_info_lz/fileUpload', params)
}

// 车辆信息编辑商业险保单信息
serverApi.crmCommercialEdit = function(params) {
  return axios.post(api+'/api.crm.car_lz/commercialEdit', params)
}

// 运输公司信息编辑投保声明（盖章资料）信息
serverApi.shopInsureEdit = function(params) {
  return axios.post(api+'/api.crm.shop_lz/insureEdit', params)
}

// 国任审核通过，批量出单-电子非见费承保
serverApi.batchAuditUnderwrite = function(params) {
  return axios.post(api+'/api.guoren.order_info_lz/batchAuditUnderwrite', params)
}

// 订单列表---导出----数据流
serverApi.orderListExport = function(params) {
  return axios.post(api+'/api.excel.order_info_product_read_lz/orderListExport2', params)
}
// 车辆管理-获取待处理（订单）事项统计
serverApi.getPendingOrder = function(params) {
  return axios.post(api+'/insurance.order_info_read_lz/getPendingOrder', params)
}
// 车辆管理-车辆档案上传影像图片
serverApi.carUploadImage = function(params) {
  return axios.post(api+'/sys.oss_upload/uploadImage', params)
}
//车辆档案-保存车辆图片（可以上传主车大本图片、挂车大本图片、营运证图片、附件图片）
serverApi.carMainUploadImg = function(params) {
  return axios.post(api+'/car.car_lz/carUploadImg', params)
}
//车辆档案-保存车辆的驾驶员信息
serverApi.carMainAddDriver = function(params) {
  return axios.post(api+'/car.car_lz/addDriver', params)
}
//运输公司pc端 -保险管理 - 系统待处理保险 线上扫码支付
serverApi.receiveMergeShopPay = function(params) {
  return axios.post(api+'insurance.OrderInfoProductLz/receive', params)
}
//运输公司pc端 -保险管理 - 系统待处理保险 前端轮询支付结果
serverApi.rollPollShopPay = function(params) {
  return axios.post(api+'insurance.OrderInfoProductLz/rollPoll', params)
}
// 险种方案信息获取父级方案
serverApi.getParenInsure = function(params) {
  return axios.post(api+'insurance.product_md_read_lz/getProductParentList', params)
}
//获取车辆档案信息列表(带承保规则校验的)
serverApi.getCarFilesInfoList = function(params) {
  return axios.post(api+'car.car_read_lz/getCarFilesInfoList', params)
}
//发送手机验证码
serverApi.sendMobile = function(params) {
  return axios.post(api+'api.shopapplet.message_lz/send', params)
}
//费用管理-获取车辆管理费用列表
serverApi.getShopFeeList = function(params) {
  return axios.post(api+'fee.shop_fee_read_lz/getShopFeeList', params)
}

//费用管理-保存车辆管理费用信息
serverApi.feeShopSave = function(params) {
  return axios.post(api+'fee.shop_fee_lz/save', params)
}

//费用管理-增加还款记录
serverApi.addFeeRepayment = function(params) {
  return axios.post(api+'fee.shop_fee_lz/addRepayment', params)
}

//费用管理-删除费用记录
serverApi.delFeeShopFee = function(params) {
  return axios.post(api+'fee.shop_fee_lz/delShopFee', params)
}
//费用管理-根据费用id 获取单个费用详情（不带分页）
serverApi.getShopFeeInfo = function(params) {
  return axios.post(api+'fee.shop_fee_read_lz/getShopFeeInfo', params)
}
//费用管理- 获取常用选项（不带分页）
serverApi.getShopFeeOptionList = function(params) {
  return axios.post(api+'fee.shop_fee_read_lz/getShopFeeOptionList', params)
}
//费用管理-根据费用id 获取还款详情列表（不带分页）
serverApi.getRepaymentList = function(params) {
  return axios.post(api+'fee.shop_fee_read_lz/getRepaymentList', params)
}
//车辆档案-保存车辆报停信息
serverApi.baoTingSave = function(params) {
  return axios.post(api+'car.car_bao_ting_lz/save', params)
}
//车辆档案-车辆报停复始申请
serverApi.restartCar = function(params) {
  return axios.post(api+'car.car_bao_ting_lz/restartCar', params)
}
//运输公司 退保申请
serverApi.saveTUiBaoApply = function(params) {
  return axios.post(api+'car.back_insure_lz/save', params)
}
//重置密码
serverApi.setSYSPassword = function(params) {
  return axios.post(api+'sys.employee_Lz/setPassword', params)
}
//运输公司-后台用户获取短信验证码
serverApi.getSmsSYSCode = function(params) {
  return axios.post(api+'sys.Company_user_read_lz/getSmsCode', params)
}
//运输公司-后台用户重置登录密码
serverApi.rePassword = function(params) {
  return axios.post(api+'sys.Company_user_read_lz/rePassword', params)
}
//保险管理-待处理保险列表-取消渠道外订单按钮
serverApi.delOtherOrder = function(params) {
  return axios.post(api+'insurance.order_info_product_lz/delOtherOrder', params)
}
//保险管理-待处理保险列表-编辑渠道外订单按钮
serverApi.editOtherOrderInfo = function(params) {
  return axios.post(api+'insurance.order_info_product_lz/editOtherOrderInfo', params)
}
//保险管理-待处理保险列表-编辑渠道外订单按钮
serverApi.saveCarAnnual = function(params) {
  return axios.post(api+'remind.remind_lz/saveCarAnnual', params)
}
//到期提醒-车辆年审到期提醒数量统计
serverApi.getAnnualRemindBtn = function(params) {
  return axios.post(api+'remind.remind_read_lz/getAnnualRemindBtn', params)
}
//到期提醒-营运证到期提醒
serverApi.getSysTradRemindList = function(params) {
  return axios.post(api+'remind.remind_read_lz/getTradRemindList', params)
}
//到期提醒-到期提醒-营运证年审到期提醒数量统计
serverApi.getTradRemindBtn = function(params) {
  return axios.post(api+'remind.remind_read_lz/getTradRemindBtn', params)
}
//到期提醒-营运证已年审提交
serverApi.saveTradeAnnual = function(params) {
  return axios.post(api+'remind.remind_lz/saveTradeAnnual', params)
}
//到期提醒-获取车辆到期提醒保险数量统计
serverApi.getCarRemindBtn = function(params) {
  return axios.post(api+'remind.remind_read_lz/getCarRemindBtn', params)
}
//获取车辆到期提醒保险详情导出excel
serverApi.getCarRemindToExcel = function(params) {
  return axios.post(api+'remind.remind_read_lz/getCarRemindToExcel', params)
}
//excel导入保单接口
serverApi.orderExcelImport = function(params) {
  return axios.post(api+'insurance.order_excel/save', params)
}
//pdf导入保单接口
serverApi.orderPdfImport = function(params) {
  return axios.post(api+'dockingAuto.FileDispose/fileUploadVehicle', params)
}




// 对比不一致文档列表
serverApi.errorLists = function(params) {
  return axios.post(api+'insurance.order_excel/error_lists', params)
}
// 展示保单基本信息
serverApi.lists = function(params) {
  return axios.post(api+'insurance.order_excel/lists', params)
}
// 删除保单基本信息
serverApi.delIndex = function(params) {
  return axios.post(api+'insurance.order_excel/del', params)
}
// 保存保单信息
serverApi.saveGroupByCarNew = function(params) {
  return axios.post(api+'insurance.order_info_Lz/saveGroupByCarNew', params)
}

// 重新获取对公扫码
serverApi.getagain = function(params) {
  return axios.post(api+'insurance.Order_account_read_lz/again_add', params)
}
// 对公扫码付款
serverApi.getScanpay = function(params) {
  return axios.post(api+'insurance.Order_account_read_lz/add', params)
}

export default serverApi;



// WEBPACK FOOTER //
// ./src/api/api.js